import { rememberLandingExampleForLogin } from "./landingExample.js";
import { appendSignupAttributionParams } from "./attribution.js";

const PROVIDERS = new Set(["apple", "google", "kakao", "naver"]);

export const buildOAuthStartURL = ({
  provider,
  serverUri,
  hostname,
  referralCode = "",
}) => {
  if (!PROVIDERS.has(provider)) {
    throw new Error("unsupported oauth provider");
  }
  rememberLandingExampleForLogin(window.location.search);
  const isLocal = ["localhost", "127.0.0.1"].includes(hostname);
  const params = new URLSearchParams({
    redirect_source: isLocal ? "localhost" : "front",
  });
  if (referralCode) params.set("referralCode", referralCode);
  appendSignupAttributionParams(params);

  const path = provider === "apple" ? "/login/apple/start" : `/login/${provider}`;
  return `${serverUri}${path}?${params.toString()}`;
};

export const buildLocalDevLoginURL = ({
  serverUri,
  frontendOrigin,
  hostname,
  appEnv,
  token = "local-dev-token",
}) => {
  if (
    appEnv !== "local" ||
    !["localhost", "127.0.0.1"].includes(hostname)
  ) {
    return "";
  }

  let backendURL;
  try {
    backendURL = new URL(serverUri);
  } catch (_) {
    return "";
  }
  if (!["localhost", "127.0.0.1"].includes(backendURL.hostname)) {
    return "";
  }

  const url = new URL("/dev/auth/login", backendURL);
  url.searchParams.set("token", token);
  url.searchParams.set("redirect", `${frontendOrigin}/main`);
  return url.toString();
};
